import BaseDecorator from "./BaseDecorator";

export default class PaymentProfileProductAttachmentDecorator extends BaseDecorator {
  static get date_limit_types() {
    return [
      ["no_date_limit", I18n.t("base.no")],
      [
        "days_before_arrival_date_limit",
        I18n.humanAttributeName("payment_profile_product_attachment", "days_before_arrival_date_limit"),
      ],
    ];
  }

  static build(attributes = {}) {
    return new PaymentProfileProductAttachmentDecorator({
      ...attributes,
      active: true,
      date_limit_type: "no_date_limit",
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/PaymentProfileProductAttachmentDecorator.js